import { z } from 'zod';

/**
 * Debug-only schema for POST /v1/debug/turnstile-verify.
 *
 * A public helper endpoint used by outlinked.ai/debug-turnstile.html to
 * exercise the server-side siteverify chain end-to-end. NOT a
 * production surface — no rate limit, no auth. Returns the raw
 * Cloudflare response so the debug page can display success + error
 * codes + hostname + timestamps for diagnosis.
 */

export const DebugTurnstileVerifyRequest = z.object({
  token: z.string().min(1).max(2048),
});

export const DebugTurnstileVerifyResponse = z.object({
  success: z.boolean(),
  errorCodes: z.array(z.string()).optional(),
});
